"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = exports.OPACITY = exports.COLOR_DICTIONARY = void 0;
const next_utils_enums_segment_1 = require("@gerenciatd/next.utils.enums.segment");
const BLUE = 'BLUE';
const BLUE_A = 'BLUE';
const BLUE10 = 'BLUE10';
const BLUE30 = 'BLUE30';
const BLUE55 = 'BLUE55';
const BLUE_DARK = 'BLUE_DARK';
const BLUE_DARK1 = 'BLUE_DARK1';
const WHITE = 'WHITE';
const BLACK = 'BLACK';
const GREY = 'GREY';
const GREY1 = 'GREY1';
const GREY2 = 'GREY2';
const GREY3 = 'GREY3';
const GREY4 = 'GREY4';
const GREY5 = 'GREY5';
const GREY6 = 'GREY6';
const GREY9 = 'GREY9';
const GREY_1 = 'GREY_1';
const GREY_2 = 'GREY_2';
const GREY_3 = 'GREY_3';
const GREY_4 = 'GREY_4';
const GREY_5 = 'GREY_5';
const GREY_6 = 'GREY_6';
const GREY_9 = 'GREY_9';
const PURPLE = 'PURPLE';
const PURPLE10 = 'PURPLE10';
const PURPLE70 = 'PURPLE70';
const GREEN = 'GREEN';
const GREEN10 = 'GREEN10';
const GREEN70 = 'GREEN70';
const ORANGE = 'ORANGE';
const ORANGE10 = 'ORANGE10';
const ORANGE80 = 'ORANGE80';
const RED = 'RED';
const RED10 = 'RED10';
const RED55 = 'RED55';
const RED70 = 'RED70';
const YELLOW_PLUS = 'YELLOW_PLUS';
const GREEN_PLUS = 'GREEN_PLUS';
const PURPLE_PLUS = 'PURPLE_PLUS';
const PINK_PLUS = 'PINK_PLUS';
const TRANSPARENT = 'TRANSPARENT';
const INHERIT = 'INHERIT';
exports.COLOR_DICTIONARY = {
    BLUE,
    BLUE_A,
    BLUE_DARK,
    BLUE_DARK1,
    WHITE,
    BLACK,
    GREY,
    GREY1,
    GREY2,
    GREY3,
    GREY4,
    GREY5,
    GREY6,
    GREY9,
    GREY_1,
    GREY_2,
    GREY_3,
    GREY_4,
    GREY_5,
    GREY_6,
    GREY_9,
    BLUE10,
    BLUE30,
    BLUE55,
    PURPLE,
    PURPLE10,
    PURPLE70,
    GREEN,
    GREEN10,
    GREEN70,
    ORANGE,
    ORANGE10,
    ORANGE80,
    RED,
    RED10,
    RED55,
    RED70,
    YELLOW_PLUS,
    GREEN_PLUS,
    PURPLE_PLUS,
    PINK_PLUS,
    TRANSPARENT,
    INHERIT,
};
const COLORS = {
    gp: {
        [exports.COLOR_DICTIONARY.BLUE]: '#019DF4',
        [exports.COLOR_DICTIONARY.BLUE_DARK]: '#0B2739',
        [exports.COLOR_DICTIONARY.BLUE_DARK1]: '#0B2739',
        [exports.COLOR_DICTIONARY.WHITE]: '#ffffff',
        [exports.COLOR_DICTIONARY.BLACK]: '#000000',
        [exports.COLOR_DICTIONARY.GREY]: '#2A2A3C',
        [exports.COLOR_DICTIONARY.GREY1]: '#F5F5F5',
        [exports.COLOR_DICTIONARY.GREY2]: '#EEEEEE',
        [exports.COLOR_DICTIONARY.GREY3]: '#DDDDDD',
        [exports.COLOR_DICTIONARY.GREY4]: '#999999',
        [exports.COLOR_DICTIONARY.GREY5]: '#86888C',
        [exports.COLOR_DICTIONARY.GREY6]: '#313235',
        [exports.COLOR_DICTIONARY.GREY9]: '#031A34',
        [exports.COLOR_DICTIONARY.BLUE10]: '#E6F5FD',
        [exports.COLOR_DICTIONARY.BLUE30]: '#80CEF9',
        [exports.COLOR_DICTIONARY.BLUE55]: '#008EDD',
        [exports.COLOR_DICTIONARY.PURPLE]: '#A13EA1',
        [exports.COLOR_DICTIONARY.PURPLE10]: '#F6ECF6',
        [exports.COLOR_DICTIONARY.PURPLE70]: '#712B71',
        [exports.COLOR_DICTIONARY.GREEN]: '#5CB615',
        [exports.COLOR_DICTIONARY.GREEN10]: '#EFF8E8',
        [exports.COLOR_DICTIONARY.GREEN70]: '#407F0F',
        [exports.COLOR_DICTIONARY.ORANGE]: '#F28D15',
        [exports.COLOR_DICTIONARY.ORANGE10]: '#FEF4E8',
        [exports.COLOR_DICTIONARY.ORANGE80]: '#6D3F09',
        [exports.COLOR_DICTIONARY.RED]: '#FF374A',
        [exports.COLOR_DICTIONARY.RED10]: '#FFEBED',
        [exports.COLOR_DICTIONARY.RED55]: '#D73241',
        [exports.COLOR_DICTIONARY.RED70]: '#B22634',
        [exports.COLOR_DICTIONARY.TRANSPARENT]: 'transparent',
        [exports.COLOR_DICTIONARY.INHERIT]: 'inherit',
    },
    emp: {
        [exports.COLOR_DICTIONARY.BLUE]: '#0066FF',
        [exports.COLOR_DICTIONARY.BLUE_DARK]: '#0B2739',
        [exports.COLOR_DICTIONARY.BLUE_DARK1]: '#0B2739',
        [exports.COLOR_DICTIONARY.WHITE]: '#FFFFFF',
        [exports.COLOR_DICTIONARY.BLACK]: '#000000',
        [exports.COLOR_DICTIONARY.GREY]: '#2A2A3C',
        [exports.COLOR_DICTIONARY.GREY1]: '#F2F4FF',
        [exports.COLOR_DICTIONARY.GREY2]: '#D1D5E4',
        [exports.COLOR_DICTIONARY.GREY3]: '#B0B6CA',
        [exports.COLOR_DICTIONARY.GREY4]: '#8F97AF',
        [exports.COLOR_DICTIONARY.GREY5]: '#6E7894',
        [exports.COLOR_DICTIONARY.GREY6]: '#58617A',
        [exports.COLOR_DICTIONARY.GREY9]: '#031A34',
        [exports.COLOR_DICTIONARY.BLUE10]: '#E6F5FD',
        [exports.COLOR_DICTIONARY.BLUE30]: '#80CEF9',
        [exports.COLOR_DICTIONARY.BLUE55]: '#008EDD',
        [exports.COLOR_DICTIONARY.PURPLE]: '#A13EA1',
        [exports.COLOR_DICTIONARY.PURPLE10]: '#F6ECF6',
        [exports.COLOR_DICTIONARY.PURPLE70]: '#712B71',
        [exports.COLOR_DICTIONARY.GREEN]: '#00B981',
        [exports.COLOR_DICTIONARY.GREEN10]: '#EFF8E8',
        [exports.COLOR_DICTIONARY.GREEN70]: '#407F0F',
        [exports.COLOR_DICTIONARY.ORANGE]: '#EC624B',
        [exports.COLOR_DICTIONARY.ORANGE10]: '#FEF4E8',
        [exports.COLOR_DICTIONARY.ORANGE80]: '#6D3F09',
        [exports.COLOR_DICTIONARY.RED]: '#D23C31',
        [exports.COLOR_DICTIONARY.RED10]: '#FFEBED',
        [exports.COLOR_DICTIONARY.RED55]: '#D73241',
        [exports.COLOR_DICTIONARY.RED70]: '#B22634',
        [exports.COLOR_DICTIONARY.TRANSPARENT]: 'transparent',
        [exports.COLOR_DICTIONARY.INHERIT]: 'inherit',
    },
    plus: {
        [exports.COLOR_DICTIONARY.YELLOW_PLUS]: '#F2B820',
        [exports.COLOR_DICTIONARY.GREEN_PLUS]: '#A9CF38',
        [exports.COLOR_DICTIONARY.PURPLE_PLUS]: '#7350CD',
        [exports.COLOR_DICTIONARY.PINK_PLUS]: '#F03C87',
        [exports.COLOR_DICTIONARY.TRANSPARENT]: 'transparent',
        [exports.COLOR_DICTIONARY.INHERIT]: 'inherit',
    }
};
exports.OPACITY = {
    '00': '00',
    '10': '1A',
    '20': '33',
    '30': '4D',
    '40': '66',
    '50': '80',
    '60': '99',
    '70': 'B3',
    '80': 'CC',
    '90': 'E6',
    '100': 'FF',
};
const getColor = (colorId, opacity = '', segment = `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`) => {
    if (colorId) {
        let colorIdMayus = colorId.toUpperCase();
        if (colorIdMayus.startsWith('GREY')) {
            colorIdMayus = colorIdMayus.replace('_', '');
        }
        if (colorIdMayus === 'BLUE_DARK1' || colorIdMayus === 'BLUE-DARK1') {
            colorIdMayus = 'BLUE_DARK';
        }
        if (colorIdMayus === 'BLUE-A' || colorIdMayus === 'BLUE_A') {
            colorIdMayus = 'BLUE';
        }
        const mySegmentNormalized = (0, next_utils_enums_segment_1.getCssSegment)(segment);
        if (colorIdMayus && COLORS[mySegmentNormalized] && COLORS[mySegmentNormalized][colorIdMayus]) {
            if (colorIdMayus === 'TRANSPARENT' || colorIdMayus === 'INHERIT') {
                return `${COLORS[mySegmentNormalized][colorIdMayus]}`;
            }
            return `${COLORS[mySegmentNormalized][colorIdMayus]}${opacity && opacity !== 'FF' ? opacity : ''}`;
        }
    }
    return '#2A2A3C';
};
exports.getColor = getColor;
exports.default = exports.getColor;
//# sourceMappingURL=index.js.map